import { myAxios } from "./common";

/**
 * Cihaz/oturum bilgisi toplama — account-sharing tespiti için (Faz 1).
 * Bu fazda hiçbir engelleme yok, sadece backend'e bilgi gönderiyoruz.
 */

const DEVICE_ID_KEY = "kaizu_device_id";

export interface ClientInfo {
  deviceId: string;
  screen: string;
  timezone: string;
  language: string;
}

/** localStorage'da kalıcı cihaz kimliği — ilk çağrıda üretilir. */
function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : // çok eski tarayıcı fallback'i
          "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          });
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

/** Login/refresh body'sine eklenecek cihaz bilgisi. */
export function getClientInfo(): ClientInfo {
  return {
    deviceId: getOrCreateDeviceId(),
    screen:
      typeof window !== "undefined"
        ? `${window.screen?.width || 0}x${window.screen?.height || 0}`
        : "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    language: navigator?.language || "",
  };
}

/**
 * Zaten login olmuş kullanıcılar için: uygulama açılışında çağrılır.
 * Token uzun ömürlü (180 gün) olduğundan bu kullanıcılar /login'e tekrar gelmez,
 * cihaz bilgisi buradan toplanır. Fire-and-forget — hata sessizce yutulur.
 */
export function reportSessionInfo(): void {
  try {
    myAxios
      .post("/user/session-info", { clientInfo: getClientInfo() })
      .catch(() => {});
  } catch {
    /* tracking asla uygulamayı bozmaz */
  }
}
